module.exports = __webpack_public_path__ + "static/media/Manual.b1c6edf0.pdf";